import { memo } from 'react';
import styled from 'styled-components';

import { RequestSummary } from '@/domain/newRequest';
import Summary from '@/pages/NewRequest/Summary/Summary';

interface ILimitSummaryProps {
    className?: string;
    summary?: RequestSummary;
}

const LimitSummary = ({ summary, className }: ILimitSummaryProps) => {
    return (
        <div className={className}>
            <Summary requestSummary={summary} />
        </div>
    );
};

const Memoized = memo(LimitSummary);
const Styled = styled(Memoized)``;

export default Styled;
